export default __webpack_public_path__ + "static/media/mov.5909ba82.svg";